import React from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

import {
    MenuItem
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    field: {
        width: '100%'
    }
}));

export const Select = ({ name, label, helperText, disabled, options, isLoading, ...props }) => {
    const classes = useStyles();

    return (
        <Field
            select
            className={classes.field}
            name={name}
            variant="outlined"
            InputProps={{
                readOnly: isLoading,
            }}
            helperText={helperText}
            label={label}
            disabled={disabled}
            component={TextField}
            {...props}>
            {options && options.length > 0 &&
                options.map((option, index) => {
                    return (
                        <MenuItem key={index} value={option.value}>
                            {option.label}
                        </MenuItem>
                    );
                })}
        </Field>
    );
}